import type { PlaycastPlayerInputAccess } from '@playcastdotio/CoreTypes';
import type {
  PlaycastMessage,
  PlaycastMessagePlayerSetConnected,
  PlaycastMessagePlayerSetDisconnected,
  PlaycastMessagePlayerSetInputAccess,
  PlaycastMessageSource,
} from '../types';
import { formatMessage } from './_util/formatMessage';

const target = 'player';

export const setInputAccess = (
  hostAuthId: string,
  access: PlaycastPlayerInputAccess,
  userAuth?: string,
): PlaycastMessage<PlaycastMessagePlayerSetInputAccess> => {
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessagePlayerSetInputAccess = {
    target,
    action: 'setInputAccess',
    isReply: false,
    message: {
      access,
    },
  };
  return formatMessage(hostAuthId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessagePlayerSetInputAccess>;
};

export const setConnected = (
  hostAuthId: string,
  playerId: string,
  userAuth?: string,
): PlaycastMessage<PlaycastMessagePlayerSetConnected> => {
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessagePlayerSetConnected = {
    target,
    action: 'setConnected',
    isReply: false,
    message: {
      playerId,
    },
  };
  return formatMessage(hostAuthId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessagePlayerSetConnected>;
};

export const setDisconnected = (
  hostAuthId: string,
  playerId: string,
  userAuth?: string,
): PlaycastMessage<PlaycastMessagePlayerSetDisconnected> => {
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessagePlayerSetDisconnected = {
    target,
    action: 'setDisconnected',
    isReply: false,
    message: {
      playerId,
    },
  };
  return formatMessage(hostAuthId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessagePlayerSetDisconnected>;
};
